/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Learn_MethodInputs */

const en_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn the Egly Method`)
};

const es_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprender el método Egly`)
};

const de_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lernen Sie die Egly-Methode`)
};

const zh_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习 Egly Method`)
};

const ar_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعرّف على منهج Egly`)
};

const fr_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apprenez la méthode Egly`)
};

const vi_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm hiểu Phương pháp Egly`)
};

const sw_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jifunze Mbinu ya Egly`)
};

const th_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียนรู้วิธีการของ Egly`)
};

const bs_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učite Egly metodu`)
};

const ja_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Methodを学ぶ`)
};

const ko_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly 메서드 알아보기`)
};

const pt_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprenda o Egly Method`)
};

const it_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imparare il Egly Method`)
};

const sv_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lär dig Egly Method`)
};

const nl_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Egly Method leren`)
};

const da_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lær Egly Method`)
};

const nb_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lær Egly Method`)
};

const fi_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opi Egly Method`)
};

const pl_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naucz się Egly Method`)
};

const ru_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть Egly Method`)
};

const tr_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method'i öğrenin`)
};

const hi_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method जानें`)
};

const id_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari Egly Method`)
};

const ms_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari Egly Method`)
};

const cs_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naučte se Egly Method`)
};

const el_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μάθετε τη Μέθοδο Egly`)
};

const he_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עקבו אחרי Egly Method`)
};

const af_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer die Egly-metode`)
};

const hu_about_learn_method = /** @type {(inputs: About_Learn_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismerje meg az Egly Method`)
};

/**
* | output |
* | --- |
* | "Learn the Egly Method" |
*
* @param {About_Learn_MethodInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_learn_method = /** @type {((inputs?: About_Learn_MethodInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Learn_MethodInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_learn_method(inputs)
	if (locale === "de") return de_about_learn_method(inputs)
	if (locale === "zh") return zh_about_learn_method(inputs)
	if (locale === "ar") return ar_about_learn_method(inputs)
	if (locale === "fr") return fr_about_learn_method(inputs)
	if (locale === "vi") return vi_about_learn_method(inputs)
	if (locale === "sw") return sw_about_learn_method(inputs)
	if (locale === "th") return th_about_learn_method(inputs)
	if (locale === "bs") return bs_about_learn_method(inputs)
	if (locale === "ja") return ja_about_learn_method(inputs)
	if (locale === "ko") return ko_about_learn_method(inputs)
	if (locale === "pt") return pt_about_learn_method(inputs)
	if (locale === "it") return it_about_learn_method(inputs)
	if (locale === "sv") return sv_about_learn_method(inputs)
	if (locale === "nl") return nl_about_learn_method(inputs)
	if (locale === "da") return da_about_learn_method(inputs)
	if (locale === "nb") return nb_about_learn_method(inputs)
	if (locale === "fi") return fi_about_learn_method(inputs)
	if (locale === "pl") return pl_about_learn_method(inputs)
	if (locale === "ru") return ru_about_learn_method(inputs)
	if (locale === "tr") return tr_about_learn_method(inputs)
	if (locale === "hi") return hi_about_learn_method(inputs)
	if (locale === "id") return id_about_learn_method(inputs)
	if (locale === "ms") return ms_about_learn_method(inputs)
	if (locale === "cs") return cs_about_learn_method(inputs)
	if (locale === "el") return el_about_learn_method(inputs)
	if (locale === "he") return he_about_learn_method(inputs)
	if (locale === "af") return af_about_learn_method(inputs)
	if (locale === "hu") return hu_about_learn_method(inputs)
	return en_about_learn_method(inputs)
});